import {
  Box,
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
} from '@chakra-ui/react';

import { useNavigate } from 'react-router-dom';

import {
  ChevronDownOutline,
  ProfileCircleOutline,
  LockOutline,
  LogoutOutline,
} from '@aslanpay/portal-common-lib';

import useAuthContext from 'app/hooks/useAuthContext';
import useSignOut from 'app/hooks/useSignOut';

import { getChangePasswordPath, getMyProfilePath } from 'app/utils/routes';

import CustomBreadcrumb from './CustomBreadcrumb';

function Navbar() {
  const { user } = useAuthContext();

  const navigate = useNavigate();

  const { mutate: signOut } = useSignOut();

  return (
    <Flex
      h="60px"
      px={{ base: '16px', sm: '30px', md: '40px' }}
      gap="10px"
      align="center"
      justify="space-between"
      bg="brand.white"
      borderBottom="1px solid"
      borderColor="brand.lightGray1"
    >
      <Box flex={1} minW={0}>
        <CustomBreadcrumb />
      </Box>
      <Menu autoSelect={false}>
        <MenuButton
          as={Button}
          variant="link"
          size="sm"
          fontWeight="600"
          rightIcon={<ChevronDownOutline boxSize="20px" />}
        >
          {`${user?.firstName} ${user?.lastName}` || 'User not found'}
        </MenuButton>
        <MenuList>
          <MenuItem
            color="brand.black"
            icon={<ProfileCircleOutline color="brand.darkGray" boxSize="14px" />}
            onClick={() => navigate(getMyProfilePath())}
          >
            My profile
          </MenuItem>
          <MenuDivider />
          <MenuItem
            color="brand.black"
            icon={<LockOutline color="brand.darkGray" boxSize="14px" />}
            onClick={() => navigate(getChangePasswordPath())}
          >
            Change password
          </MenuItem>
          <MenuDivider />
          <MenuItem
            color="brand.black"
            icon={<LogoutOutline color="brand.darkGray" boxSize="14px" />}
            onClick={() => signOut()}
          >
            Log out
          </MenuItem>
        </MenuList>
      </Menu>
    </Flex>
  );
}

export default Navbar;
